var ColoredAssistChip_types_AssistChipColor = /*#__PURE__*/ function(AssistChipColor) {
    AssistChipColor["gray"] = "gray";
    AssistChipColor["green"] = "green";
    AssistChipColor["orange"] = "orange";
    AssistChipColor["red"] = "red";
    AssistChipColor["blue"] = "blue";
    AssistChipColor["purple"] = "purple";
    return AssistChipColor;
}({});
export { ColoredAssistChip_types_AssistChipColor as AssistChipColor };
